import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import ColorBarViewModelType from '@/ViewModels/Controls/ColorBarViewModel';
import LabelType from '@/Controls/Label';
import Utilities from '@/Utility/Utilities';

export default class ColorBar extends Control {

    private Label = ComponentManager.getControl<typeof LabelType>('Label');
    private jQueryControl: JQuery;
    private bar: JQuery;
    private label: LabelType;

    public constructor(private viewModel: ColorBarViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');
        this.bar = $('<div class="bar">').appendTo(this.jQueryControl);

        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'colorbar',

            visible: this.viewModel.isVisible,

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            focus: this.viewModel.isFocusable,

            tooltip: this.viewModel.tooltip,

            locator: this.viewModel.locator
        });

        if (this.viewModel.label != null) {
            this.label = new this.Label(this.viewModel.label);
            const tuple = this.label.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }

        const rgb = ColorBar.hexToRgb(this.viewModel.color);
        const from = ColorBar.rgbToString(255, 255, 255, 1);
        const to = ColorBar.rgbToString(rgb['r'], rgb['g'], rgb['b'], 1);

        this.bar[0].style.background = `linear-gradient(to right, ${from} 0%, ${to} 100%)`;
        this.bar[0].style.width = this.viewModel.width() + '%';
    }

    private static hexToRgb(hex: string): { r: number, g: number, b: number } {
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }

    private static rgbToString(r: number, g: number, b: number, a: number): string {
        return `rgba(${r}, ${g}, ${b}, ${a})`;
    }

    private static parseMyFloat(f: string | number): number {
        if (typeof f == 'string') {
            f = f.replace(/,/g, '.');
            return parseFloat(f);
        }
        return f;
    }

    public static buildJQuery(vm: { locator: ObservableOrDefault<string>, color: string, current: string | number, complete: string | number }, showNumber: boolean = true ) {
        const elem = document.createElement('div');
        elem.className = 'c-colorbar';
        const locator = Utilities.isFunction(vm.locator) ? vm.locator() : vm.locator as string;

        if (!Utilities.isNullOrUndefined(locator)) {
            elem.setAttribute('data-locator', locator);
        }

        const rgb = ColorBar.hexToRgb(vm.color);
        const from = ColorBar.rgbToString(255, 255, 255, 1);
        const to = ColorBar.rgbToString(rgb['r'], rgb['g'], rgb['b'], 1);
        const current = ColorBar.parseMyFloat(vm.current);
        const complete = ColorBar.parseMyFloat(vm.complete);
        const width = parseInt(100 * current / complete + '');

        const bar = document.createElement('div');
        bar.className = 'bar';
        bar.style.background = `linear-gradient(to right, ${from} 0%, ${to} 100%)`;
        bar.style.width = width + '%';

        elem.appendChild(bar);

        if (showNumber) { 
            const label = document.createElement('div');
            label.className = 'c-label';
            if (!Utilities.isNullOrUndefined(locator)) {
                label.setAttribute('data-locator', locator + '.label');
            }
            label.innerText = kendo.toString(current, 'n');

            elem.appendChild(label);
        }

        return $(elem);
    }
}

ComponentManager.setControl('ColorBar', ColorBar, 'RADPresentation.HTMLClient.DefaultViewExtensions');